import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { toast } from 'sonner';
import { BaseModal } from 'wbs-components-lib';

import { useCreateVipTaskItemMutation } from '@services';

import { AppDispatch, setVipTaskItem } from '@store';

import { VipTaskItemForm, VipTaskItemFormValues, VIP_TASK_ITEM_FORM_INITIAL_VALUES } from '../../VipSettingsForms';
import { getVipTaskItemSpecificFieldsValue } from '../utlis';

import { VipTaskItemCreateModalProps } from './types';

export const VipTaskItemCreateModal: FC<VipTaskItemCreateModalProps> = ({
  isOpened,
  handleClose,
  vipTaskId,
  vipTaskType,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const [createVipTaskItem, { isLoading: isCreatingInProgress }] = useCreateVipTaskItemMutation();

  const handleCreateVipTaskItem = async (values: VipTaskItemFormValues) => {
    const createdVipTaskItem = await createVipTaskItem({
      vipTaskId,
      ...values,
      ...getVipTaskItemSpecificFieldsValue(values),
    }).unwrap();

    dispatch(setVipTaskItem(createdVipTaskItem));

    toast.success('Success: VIP task item has been created!');

    handleClose();
  };

  return (
    <BaseModal headerTitle="Create VIP task item" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipTaskItemForm
        initialValues={VIP_TASK_ITEM_FORM_INITIAL_VALUES}
        isSubmitting={isCreatingInProgress}
        onSubmit={handleCreateVipTaskItem}
        vipTaskType={vipTaskType}
      />
    </BaseModal>
  );
};
